/**
 * NOTE: These types are FE only, and not reliant on the backend.
 */

import { Funnel } from "@b2bportal/core-types";

export enum PackageType {
  HOTEL_FLIGHT_CAR = "hotel_flight_car",
  HOTEL_FLIGHT = "hotel_flight",
  HOTEL_CAR = "hotel_car",
  FLIGHT_CAR = "flight_car",
}

export const ProductTypeFunnels: Record<PackageType, Funnel[]> = {
  [PackageType.HOTEL_FLIGHT_CAR]: [Funnel.Lodging, Funnel.Air, Funnel.Ground],
  [PackageType.HOTEL_FLIGHT]: [Funnel.Lodging, Funnel.Air],
  [PackageType.HOTEL_CAR]: [Funnel.Lodging, Funnel.Ground],
  [PackageType.FLIGHT_CAR]: [Funnel.Air, Funnel.Ground],
};

export const PackageEndpointsV2 = {
  Requisition: "/api/v0/packages/requisition",
  Customize: "/api/v0/packages/customize",
  Autocomplete: "/api/v0/autocomplete/packages",
  Complete: "/api/v0/packages/complete",
};
